module.exports = __webpack_public_path__ + "img/pengguna.2216319d.png";